import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getResourcesByPlant } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useSelectedResource } from '..';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to access resources.
 * @param {boolean} resourceQueues - Add resource queues to the response
 * @param {boolean} [active] - Filter for active resources
 */
export const useResources = (resourceQueues, active) => {
  const { apiReady } = useApiReady();
  const { selectedPlant } = useAppContext();
  const { setSelectedResource } = useSelectedResource();

  return useQuery({
    queryKey: [QUERY_KEYS.RESOURCE_DATA, selectedPlant, { active, resourceQueues }, setSelectedResource],
    queryFn: async () => {
      const resources = await getResourcesByPlant(selectedPlant, resourceQueues, { active });

      // If no data is returned, clear previous selection
      if (!resources.length) setSelectedResource('');

      return resources;
    },
    select: (data) => {
      let newData = [];

      if (resourceQueues)
        newData = data.map((resource) => {
          if (resource?.resourceQueues?.length) {
            return {
              ...resource,
              resourceQueues: resource.resourceQueues.map((rq) => ({
                ...rq,
                id: rq.queueId,
                description: rq.queue.description,
              })),
            };
          }

          return { ...resource, resourceQueues: [] };
        });

      return newData.length ? newData : data;
    },
    staleTime: Infinity,
    enabled: Boolean(apiReady && selectedPlant),
  });
};
